import { Box } from "@mui/system";
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import { Button } from "@mui/material";
import { useContext, useState } from "react";
import AddFileModal from "./AddFileModal";
import ControlledTreeView from "./ControlledTreeView";
import { AppContext } from "../../../scripts/context/App";
import toast from "react-hot-toast";

export default function FileStructure() {
  const { user } = useContext(AppContext);
  const [addFileModalStatus, setAddFileModalStatus] = useState(false);

  return (
    <>
      <AddFileModal
        isOpen={addFileModalStatus}
        setISOpen={setAddFileModalStatus}
      />
      <Box sx={{
        borderTop: "1px solid #0000001f",
        pt: 3,
        mt: 3,
      }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            mb: 1,
          }}
        >
          <Button
            variant="text"
            startIcon={<CreateNewFolderOutlinedIcon />}
            color="inherit"
            onClick={() => {
              if (!user.permissions.includes("create_folder")) return toast.error("You don't have permission to create folders");

              setAddFileModalStatus(true);
            }}
          >
            New Folder
          </Button>
        </Box>

        <ControlledTreeView />
      </Box>
    </>
  );
}
